export default "__VITE_ASSET__DrbDENdT__"